import React from 'react';
import sortBy from 'lodash/sortBy';
import classNames from 'classnames';

import BundleProductCard from 'Features/Bundle/components/Cards/BundleProductCard';
import useViewport from 'Hooks/useViewport';


const BundleRedesignProducts = ({
  bundleTiers = [],
  switchCarouselGame = () => { },
  bundleSlug = '',
  templateType = '',
}) => {
  const isBook = templateType === 'book' || templateType === 'comic';
  const { isLg } = useViewport();
  const filteredBundleTier = sortBy(bundleTiers[0].games, ['sort_order']).filter(game => game.display);
  return (
    <section className="fan-grid-container">
      {filteredBundleTier.map((p, i) => {
        const index = i + 1;
        return (
          <div className={classNames({ 'two-column-row': isLg || !isBook }, { 'three-column-row': isBook && !isLg })} key={p._id + index}>
            <BundleProductCard
              product={p}
              switchCarouselGame={switchCarouselGame}
              sizesOverride="(min-width: 1520px) 420px, (min-width: 1200px) 360px, (min-width: 992px) 300px, (min-width: 768px) 220px, (min-width: 576px) 255px, 50vw"
              bundleSlug={bundleSlug}
            />
          </div>
        );
      })}
    </section>
  );
};

export default BundleRedesignProducts;
